@layer module {
.modal-dialog-wrapper {
            position: fixed;
            outline: 0;
            overflow-x: hidden;
            overflow-y: auto;
            z-index: 5000;
            display: flex;
            align-items: center;
            justify-content: center;
    }

.modal-dialog-wrapper.overflowing {
            align-items: flex-start;
    }

.modal-container {
            padding: 0;
            display: inline-grid;
            grid-template-areas: 'main';
            grid-template-columns: 1fr;
            grid-gap: 0;
    }

.modal-container .popup-main-content {
            grid-area: main;
            position: relative;
            transform-style: preserve-3d;
            perspective: 1000px;
            animation: modalZoomIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
    }

.modal-container .popup-close-button-inline {
            cursor: pointer;
            display: grid;
            place-items: center;
            position: absolute;
            padding: 0;
            border: none;
            border-radius: 50%;
            z-index: 101;
    }

.scrollable .popup-main-content {
            overflow-y: auto;
    }

.scrollable .popup-main-content::-webkit-scrollbar-thumb {
            outline: none;
    }

@keyframes modalZoomIn {
0% {
            opacity: 0;
            transform: scale(0.8) translateZ(-100px);
    }

100% {
            opacity: 1;
            transform: scale(1) translateZ(0);
    }
}
} // layer module










@layer app {
.modal-dialog-wrapper {
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
    }

.modal-dialog-wrapper::-webkit-scrollbar {
            width: $size-5;
    }

.modal-container {
            margin: 0;
            height: fit-content;
    }

.modal-container .popup-main-content {
            margin: $size-35 0;
    }

.modal-container .popup-close-button-inline {
            right: $size-24;
            top: $size-24;
            width: $size-32;
            height: $size-32;
    }

.overflowing .popup-main-content {
            margin: $size-50 0 $size-20;
    }

.overflowing .scrollable {
            height: 98vh;
    }

.scrollable .popup-main-content {
            height: auto;
    }

.scrollable .popup-main-content::-webkit-scrollbar {
            width: $size-5;
    }

.modal-dialog-wrapper {
            --modal-gutter: #{$size-24};
            --modal-fill-inline-size: calc(100vw - 2 * var(--modal-gutter) - 2px);
            padding: 0 var(--modal-gutter);
            background: var(--modal-backdrop-background);
    }

.modal-container .popup-close-button-inline {
            background: var(--bg-neutral-chip);
            color: var(--text-body);
    }

.popup-close-button-inline:hover {
            background: var(--border-default);
    }

.modal-dialog-wrapper::-webkit-scrollbar-track {
            box-shadow: var(--shadow-modal-scrollbar-dark);
    }

.modal-dialog-wrapper::-webkit-scrollbar-thumb,
.scrollable .popup-main-content::-webkit-scrollbar-thumb {
            background: var(--banky-white--30);
    }

.scrollable .popup-main-content::-webkit-scrollbar-track {
            box-shadow: var(--shadow-modal-scrollbar-light);
    }
} // layer app
